export const GENDER_OPTIONS = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
  { value: "OTHER", label: "Other" },
];

export const ROLE_OPTIONS = [
  { value: "TRAINEE", label: "Trainee" },
  { value: "INSTRUCTOR", label: "Instructor" },
  { value: "ADMIN", label: "Admin" },
];

export const LOGIN_METHOD = [
  { value: "PASSWORD", label: "Password" },
  { value: "OTP", label: "OTP" },
];

export const STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
  ];
//Default records per page
export const DEFAULT_RECORDS_PER_PAGE = 10;

export const STATE_OPTIONS = [
  { value: "Maharashtra", label: "Maharashtra" },
  { value: "Karnataka", label: "Karnataka" },
  { value: "Delhi", label: "Delhi" },
  { value: "Gujarat", label: "Gujarat" },
  { value: "Rajasthan", label: "Rajasthan" },
  { value: "WestBengal", label: "West Bengal" },
];
export const CITY_OPTIONS = {
  Maharashtra: [
    { value: "Mumbai", label: "Mumbai" },
    { value: "Pune", label: "Pune" },
    { value: "Nagpur", label: "Nagpur" },
    { value: "Nashik", label: "Nashik" },
  ],
  Karnataka: [
    { value: "Bangalore", label: "Bangalore" },
    { value: "Mysore", label: "Mysore" },
    { value: "Mangalore", label: "Mangalore" },
    { value: "Hubli", label: "Hubli" },
  ],
  Delhi: [{ value: "NewDelhi", label: "New Delhi" }],
  Gujarat: [
    { value: "Ahmedabad", label: "Ahmedabad" },
    { value: "Surat", label: "Surat" },
    { value: "Vadodara", label: "Vadodara" },
  ],
  Rajasthan: [
    { value: "Jaipur", label: "Jaipur" },
    { value: "Udaipur", label: "Udaipur" },
    { value: "Jodhpur", label: "Jodhpur" },
  ],
  WestBengal: [
    { value: "Kolkata", label: "Kolkata" },
    { value: "Howrah", label: "Howrah" },
    { value: "Durgapur", label: "Durgapur" },
  ],
};
export const PINCODE_OPTIONS = {
  Mumbai: ["400001", "400002", "400003"],
  Pune: ["411001", "411002", "411003"],
  Nagpur: ["440001", "440002"],
  Nashik: ["422001", "422002"],
  Bangalore: ["560001", "560002", "560003"],
  Mysore: ["570001", "570002"],
  Mangalore: ["575001", "575002"],
  Hubli: ["580001", "580002"],
  NewDelhi: ["110001", "110002"],
  Ahmedabad: ["380001", "380002"],
  Surat: ["395001", "395002"],
  Vadodara: ["390001", "390002"],
  Jaipur: ["302001", "302002"],
  Udaipur: ["313001", "313002"],
  Jodhpur: ["342001", "342002"],
  Kolkata: ["700001", "700002"],
  Howrah: ["711101", "711102"],
  Durgapur: ["713201", "713202"],
};

export const TRAINING_CENTER = [
  { value: "TECH_SKILLS_ACADEMY", label: "Tech Skills Academy" },
  { value: "CODENEXT_CENTER", label: "CodeNext Center" },
  { value: "SKILLUP_INSTITUTE", label: "SkillUp Institute" },
  { value: "DIGITAL_EDGE_ACADEMY", label: "Digital Edge Academy" },
  { value: "FUTURE_LEARN_HUB", label: "Future Learn Hub" },
];
export const CHANNEL_PARTNER = [
  { value: "SKILLBRIDGE_PARTNERS", label: "SkillBridge Partners" },
  { value: "LEARNHUB_ASSOCIATES", label: "LearnHub Associates" },
  { value: "EDUCONNECT_SERVICES", label: "EduConnect Services" },
  { value: "NEXTGEN_TRAINING_SOLUTIONS", label: "NextGen Training Solutions" },
  { value: "INNOVATE_EDTECH", label: "Innovate EdTech" },
];

export const COURSE_CATEGORY = [
  {
    value: "TECHNICAL_TRADE",
    label: "Technical & Trade Training",
  },
  {
    value: "SAFETY_COMPLIANCE",
    label: "Safety & Compliance",
  },
  {
    value: "OPERATIONS_MAINTENANCE",
    label: "Operations & Maintenance",
  },
];

export const COURSE_LEVELS = [
  { value: "BEGINNER", label: "Beginner" },
  { value: "INTERMEDIATE", label: "Intermediate" },
  { value: "ADVANCED", label: "Advanced" },
];

export const COURSE_LANGUAGES = [
  { value: "ENGLISH", label: "English" },
  { value: "HINDI", label: "Hindi" },
];
export const REQUIRED_DOCUMENTS = [
  { value: "10th_grade_ssc", label: "10th Grade / SSC" },
  { value: "12th_grade", label: "12th Grade" },
  { value: "diploma_certificate", label: "Diploma Certificate" },
  {
    value: "bachelor_degree_certificate",
    label: "Bachelor Degree Certificate",
  },
  {
    value: "professional_certificate",
    label:
      "Professional Certificate (e.g., PWS, AWS, MS Office Specialization)",
  },
];
export const ADD_NEW_DOC_OPTION = {
  value: "ADD_NEW",
  label: "+ Add New Document",
};
export const COMPLETION_CRITERIA = [
  // { value: "PROGRESS", label: "Progress" },
  { value: "ATTENDANCE", label: "Attendance" },
  // { value: "PASSING_SCORE", label: "Passing Score" },
];

export const CRITERIA_DEPENDENT_OPTIONS = {
  PASSING_SCORE: [
    { value: 90, label: "90%" },
    { value: 70, label: "70%" },
    { value: 50, label: "50%" },
  ],
  ATTENDANCE: [
    { value: 100, label: "100%" },
    { value: 75, label: "75%" },
  ],
  PROGRESS: [
    { value: 100, label: "100% Completion" },
    { value: 80, label: "80% Completion" },
    { value: 50, label: "50% Completion" },
  ],
};

export const VALIDITY = [
  {
    label: "No Expiry",
    value: {
      durationType: "",
      durationValue: 0,
    },
  },
  {
    label: "3 Months",
    value: {
      durationType: "MONTH",
      durationValue: 3,
    },
  },
  {
    label: "6 Months",
    value: {
      durationType: "MONTH",
      durationValue: 6,
    },
  },
  {
    label: "12 Months",
    value: {
      durationType: "MONTH",
      durationValue: 12,
    },
  },
];

export const COURSE_TYPE = [
  { value: "IMAGE", label: "Image" },
  { value: "PDF", label: "PDF document" },
  { value: "VIDEO", label: "Video" },
  { value: "DOCUMENT", label: "Word document" },
  { value: "SHEET", label: "Excel file" },
  // { value: "URL", label: "Links / URL" },
];

export const CERTIFICATE_TYPE_OPTIONS = [
  // { value: "training", label: "Training" },
  { value: "COMPLETION", label: "Completion" },
  { value: "PARTICIPATION", label: "Participation" },
  { value: "BOTH", label: "Both" },
];

export const CERTIFICATE_TEMPLATE_TYPE_OPTIONS = [
  { value: "COMPLETION", label: "Completion" },
  { value: "PARTICIPATION", label: "Participation" },
];

export const STROKE_WIDTH_OPTIONS = [
  { value: 1, label: "1 px" },
  { value: 2, label: "2 px" },
  { value: 3, label: "3 px" },
  { value: 4, label: "4 px" },
  { value: 8, label: "8 px" },
  { value: 12, label: "12 px" },
  { value: 16, label: "16 px" },
  { value: 24, label: "24 px" },
];

export const DASH_OPTIONS = [
  { value: [], label: "Solid" },
  { value: [1, 6], label: "Round Dot" },
  { value: [10, 5], label: "Dash" },
];

export const PLACEHOLDER_OPTIONS = [
  { value: "trainee_name", label: "Trainee Name" },
  { value: "instructor_name", label: "Instructor Name" },
  { value: "course_name", label: "Course Name" },
  { value: "certificate_no", label: "Certificate Number" },
  { value: "issue_date", label: "Issue Date" },
  { value: "completion_date", label: "Completion Date" },
  // { value: "course_duration", label: "Course Duration" },
  // { value: "assessment_score", label: "Assessment Score" },
  // { value: "verification_url", label: "Verification URL" },
  // { value: "qr_code", label: "QR Code" },
  // { value: "course_start_date", label: "Course Start Date" },
  // { value: "course_end_date", label: "Course End Date" },
  { value: "certificate_valid_till", label: "Certificate Valid Till" },
];

export const SIGNATURE_OPTIONS = [
  { value: "director_signature", label: "Director Signature" },
  { value: "training_head_signature", label: "Training Head Signature" },
  { value: "hr_signature", label: "HR Signature" },
];

export const SIGNATURE_DOCUMENT_MAP = {
  director_signature: require("assets/img/signatures/signature1.jpeg"),
  training_head_signature: require("assets/img/signatures/signature1.jpeg"),
  hr_signature: require("assets/img/signatures/signature3.png"),
};

export const FONT_SIZE_OPTIONS = [
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 14, label: "14" },
  { value: 16, label: "16" },
  { value: 18, label: "18" },
  { value: 20, label: "20" },
  { value: 24, label: "24" },
  { value: 32, label: "32" },
  { value: 48, label: "48" },
  { value: 64, label: "64" },
];

export const FONT_OPTIONS = [
  { value: "Arial", label: "Arial" },
  { value: "Arial Black", label: "Arial Black" },
  { value: "Brush Script MT", label: "Brush Script MT" },
  { value: "Calibri", label: "Calibri" },
  { value: "Cambria", label: "Cambria" },
  { value: "Century Gothic", label: "Century Gothic" },
  { value: "Comic Sans MS", label: "Comic Sans MS" },
  { value: "Consolas", label: "Consolas" },
  { value: "Courier New", label: "Courier New" },
  { value: "Didot", label: "Didot" },
  { value: "Franklin Gothic Medium", label: "Franklin Gothic Medium" },
  { value: "Garamond", label: "Garamond" },
  { value: "Georgia", label: "Georgia" },
  { value: "Helvetica", label: "Helvetica" },
  { value: "Impact", label: "Impact" },
  { value: "Lucida Console", label: "Lucida Console" },
  { value: "Lucida Sans Unicode", label: "Lucida Sans Unicode" },
  { value: "Monaco", label: "Monaco" },
  { value: "Optima", label: "Optima" },
  { value: "Palatino Linotype", label: "Palatino Linotype" },
  { value: "Papyrus", label: "Papyrus" },
  { value: "Segoe UI", label: "Segoe UI" },
  { value: "Tahoma", label: "Tahoma" },
  { value: "Times New Roman", label: "Times New Roman" },
  { value: "Trebuchet MS", label: "Trebuchet MS" },
  { value: "Verdana", label: "Verdana" },
];

export const CERTIFICATE_SIZES = {
  A3: { width: 1000, height: 707 }, // largest (print)
  A4: { width: 707, height: 500 }, // clearly smaller than A3
  "16:9": { width: 900, height: 506 }, // screen wide
  "4:3": { width: 820, height: 615 }, // screen taller
};

export const SKILL_OPTIONS = [
  { value: "Cable Jointing", label: "Cable Jointing" },
  { value: "Substation Maintenance", label: "Substation Maintenance" },
  { value: "Transformer Testing", label: "Transformer Testing" },
  { value: "Electrical Safety", label: "Electrical Safety" },
  { value: "HT & LT Systems", label: "HT & LT Systems" },
];
export const trainerOptions = [
  { value: "sheetal_sharma", label: "Sheetal Sharma" },
  { value: "gokul_patil", label: "Gokul Patil" },
  { value: "rahul_verma", label: "Rahul Verma" },
];

export const MAX_COURSE_DESC_LENGTH = 300;

export const ADD_NEW_VALIDITY_OPTION = {
  value: "ADD_NEW",
  label: "+ Add Custom Validity",
};

export const ADD_NEW_COURSE = {
  value: "ADD_NEW",
  label: "+ Add Course Name",
};

export const PAYMENT_STATUS_OPTION = [
  { value: "CAPTURED", label: "Paid" },
  { value: "PENDING", label: "Pending" },
  { value: "FAILED", label: "Failed" },
  // { value: "FAILED", label: "Failed" },
];

export const INVOICE_TYPE = [
  { value: "GST", label: "Gst" },
  { value: "CORPORATE", label: "Corporate" },
];

export const OFFLINE_TRAINING_CENTER = [
  {
    value: "Pune Industrial Training Center",
    label: "Pune Industrial Training Center",
  },
  { value: "Bangalore Skill Hub", label: "Bangalore Skill Hub" },
  { value: "Delhi Technical Academy", label: "Delhi Technical Academy" },
  {
    value: "Chennai Manufacturing Institute",
    label: "Chennai Manufacturing Institute",
  },
  {
    value: "Ahmedabad Industrial School",
    label: "Ahmedabad Industrial School",
  },
];

export const ASSESSMENT_LIST = [
  {
    value: "Electrical Safety Basics Test",
    label: "Electrical Safety Basics Test",
  },
  { value: "Transformer Testing Quiz", label: "Transformer Testing Quiz" },
  {
    value: "Substation Maintenance Assessment",
    label: "Substation Maintenance Assessment",
  },
  { value: "HT & LT Systems Final Test", label: "HT & LT Systems Final Test" },
  {
    value: "Cable Jointing Practical Test",
    label: "Cable Jointing Practical Test",
  },
];

export const COURSE_BATCH_MAP = {
  1: [
    { value: "Batch A", label: "Batch A" },
    { value: "Batch B", label: "Batch B" },
  ],
  2: [
    { value: "Batch A", label: "Batch A" },
    { value: "Batch B", label: "Batch B" },
    { value: "Batch C", label: "Batch C" },
    { value: "Batch D", label: "Batch D" },
  ],
  3: [
    { value: "Batch A", label: "Batch A" },
    { value: "Batch B", label: "Batch B" },
  ],
};

export const ASSESSMENT_STATUS_OPTIONS = [
  // { value: "UPCOMING", label: "Upcoming" },
  // { value: "ACTIVE", label: "Active" },
  // { value: "CLOSED", label: "Closed" },
  { value: "PUBLISHED", label: "Published" },
  { value: "DRAFT", label: "Draft" },
];

export const MULTI_CORRECT_NEGATIVE_OPTIONS = [
  // { value: "__NONE__", label: "None" },
  { value: 1.0, label: "100%" },
  { value: 0.9, label: "90%" },
  { value: 0.8, label: "80%" },
  { value: 0.75, label: "75%" },
  { value: 0.666667, label: "66.67%" },
  { value: 0.6, label: "60%" },
  { value: 0.5, label: "50%" },
  { value: 0.4, label: "40%" },
  { value: 0.333333, label: "33.33%" },
  { value: 0.25, label: "25%" },
  { value: 0.2, label: "20%" },
  { value: 0.166667, label: "16.67%" },
  { value: 0.142857, label: "14.29%" },
  { value: 0.125, label: "12.5%" },
  { value: 0.111111, label: "11.11%" },
  { value: 0.1, label: "10%" },
  { value: 0.05, label: "5%" },
  { value: 0, label: "0%" },
  { value: -0.05, label: "-5%" },
  { value: -0.1, label: "-10%" },
  { value: -0.2, label: "-20%" },
  { value: -0.25, label: "-25%" },
  { value: -0.333333, label: "-33.33%" },
  { value: -0.5, label: "-50%" },
  { value: -0.75, label: "-75%" },
  { value: -1.0, label: "-100%" },
];

export const MULTI_CORRECT_POSITIVE_OPTIONS = [
  // { value: "__NONE__", label: "None" },
  { value: 1.0, label: "100%" },
  { value: 0.9, label: "90%" },
  { value: 0.8, label: "80%" },
  { value: 0.75, label: "75%" },
  { value: 0.666667, label: "66.67%" },
  { value: 0.6, label: "60%" },
  { value: 0.5, label: "50%" },
  { value: 0.4, label: "40%" },
  { value: 0.333333, label: "33.33%" },
  { value: 0.25, label: "25%" },
  { value: 0.2, label: "20%" },
  { value: 0.166667, label: "16.67%" },
  { value: 0.142857, label: "14.29%" },
  { value: 0.125, label: "12.5%" },
  { value: 0.111111, label: "11.11%" },
  { value: 0.1, label: "10%" },
  { value: 0.05, label: "5%" },
  { value: 0, label: "0%" },
];

export const SINGLE_CORRECT_NEGATIVE_OPTIONS = [
  // { value: "__NONE__", label: "None" },
  { value: 1.0, label: "100%" },
  { value: 0, label: "0%" },
  { value: -0.05, label: "-5%" },
  { value: -0.1, label: "-10%" },
  { value: -0.2, label: "-20%" },
  { value: -0.25, label: "-25%" },
  { value: -0.333333, label: "-33.33%" },
  { value: -0.5, label: "-50%" },
  { value: -0.75, label: "-75%" },
  { value: -1.0, label: "-100%" },
];

export const SINGLE_CORRECT_POSITIVE_OPTIONS = [
  // { value: "__NONE__", label: "None" },
  { value: 1.0, label: "100%" },
  { value: 0, label: "0%" },
];

export const MODULES = {
  toolbar: [
    ["bold", "italic", "link", { align: [] }],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["clean"],
  ],
};

export const LESSON_TYPE_META = {
  IMAGE: {
    icon: "fa-file-image",
    previewType: "image",
    preview:
      "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
    type: "image/jpeg",
  },

  PNG: {
    icon: "fa-file-image",
    previewType: "image",
  },

  JPG: {
    icon: "fa-file-image",
    previewType: "image",
  },

  JPEG: {
    icon: "fa-file-image",
    previewType: "image",
  },

  GIF: {
    icon: "fa-file-image",
    previewType: "image",
  },

  WEBP: {
    icon: "fa-file-image",
    previewType: "image",
  },

  PDF: {
    icon: "fa-file-pdf",
    previewType: "pdf",
    preview:
      "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    type: "application/pdf",
  },

  DOCUMENT: {
    icon: "fa-file-word",
    previewType: "document",
    preview:
      "https://file-examples.com/wp-content/uploads/2017/02/file-sample_100kB.docx",
    type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  },

  DOC: {
    icon: "fa-file-word",
    previewType: "document",
  },

  DOCX: {
    icon: "fa-file-word",
    previewType: "document",
  },

  SHEET: {
    icon: "fa-file-excel",
    previewType: "sheet",
    preview:
      "https://file-examples.com/wp-content/uploads/2017/02/file_example_XLSX_100.xlsx",
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  },

  XLS: {
    icon: "fa-file-excel",
    previewType: "sheet",
  },

  XLSX: {
    icon: "fa-file-excel",
    previewType: "sheet",
  },

  CSV: {
    icon: "fa-file-excel",
    previewType: "sheet",
  },

  VIDEO: {
    icon: "fa-video",
    previewType: "video",
    preview: "https://www.w3schools.com/html/mov_bbb.mp4",
    type: "video/mp4",
  },

  MP4: {
    icon: "fa-video",
    previewType: "video",
  },

  MOV: {
    icon: "fa-video",
    previewType: "video",
  },

  MPEG: {
    icon: "fa-video",
    previewType: "video",
  },

  AVI: {
    icon: "fa-video",
    previewType: "video",
  },

  URL: {
    icon: "fa-link",
    previewType: "url",
    preview: "https://www.google.com",
    type: "text/html",
  },
};

export const CERTIFICATE_TYPE = [
  { value: "INDIVIDUAL", label: "Individual" },
  { value: "GROUP", label: "Group" },
];

export const ROLE = [
  { value: "ADMIN", label: "Admin" },
  { value: "INSTRUCTOR", label: "Instructor" },
];

export const COURSE_OPTIONS = [
  { value: "COMPLETED", label: "Completed" },
  { value: "IN_PROGRESS", label: "In-Progress" },
];

export const CERTIFICATE_STATUS = [
  { value: "PENDING", label: "Pending" },
  { value: "ISSUED", label: "Issued" },
  { value: "EXPIRED", label: "Expired" },
];

export const TRAINEE_LETTER_STATUS = [
  { value: "ISSUED", label: "Issued" },
  { value: "EXPIRED", label: "Expired" },
];

export const COURSE_TYPES = [
  { value: "RECORDED", label: "Recorded" },
  { value: "LIVE", label: "Live" },
];

export const COURSE_MODE = [
  { value: "OFFLINE", label: "Offline" },
  { value: "ONLINE", label: "Online" },
  { value: "OFFLINE + ONLINE", label: "Offline + Online" },
];

export const COURSE_CONFIG = {
  SUPER_ADMIN: {
    showRating: true,
    showCode: true,
    showSessions: false,
    showEnrolledStudents: false,
    showCreatedBy: true,
    showCourseName: true,
    showAddCourse: true,
    showPurchase: false,
    showCreatedbyCreatedAt: true,
    showCourseStatus: true,
    showArtifacts: false,
    showAddBatch: true,
    showEdit: true,
  },
  ADMIN: {
    showRating: true,
    showCode: true,
    showSessions: false,
    showEnrolledStudents: false,
    showCreatedBy: true,
    showCourseName: true,
    showAddCourse: true,
    showPurchase: false,
    showCreatedbyCreatedAt: true,
    showCourseStatus: true,
    showArtifacts: false,
    showAddBatch: true,
    showEdit: true,
  },
  CHANNEL_PARTNER: {
    showRating: true,
    showCode: true,
    showSessions: true,
    showEnrolledStudents: true,
    showCreatedBy: true,
    showCourseName: true,
    showAddCourse: false,
    showPurchase: true,
    showCreatedbyCreatedAt: true,
    showCourseStatus: true,
    showArtifacts: false,
    showAddBatch: false,
    showEdit: false,
  },
  TRAINER: {
    showRating: false,
    showCode: false,
    showSessions: true,
    showEnrolledStudents: true,
    showCreatedBy: false,
    showCourseName: true,
    showAddCourse: false,
    showPurchase: false,
    showCreatedbyCreatedAt: false,
    showCourseStatus: false,
    showArtifacts: true,
    showAddBatch: false,
    showEdit: false,
  },
};

export const COURSE_DETAIL_TAB_CONFIG = (role, mode) => {
  // ADMIN → always all tabs
  if (role === "ADMIN" || role === "SUPER_ADMIN") {
    return {
      details: true,
      schedule: true,
      assessment: true,
      enrollment: true,
    };
  }
  // CHANNEL PARTNER
  if (role === "CHANNEL_PARTNER") {
    return {
      details: true,
      schedule: true,
      assessment: mode === "MY_COURSE",
      enrollment: mode === "MY_COURSE",
    };
  }
  //INSTRUCTOR
  if (role === "TRAINER") {
    return {
      details: true,
      schedule: true,
      assessment: true,
      enrollment: true,
    };
  }
};

export const TRAINEE_CONFIG = {
  ADMIN: {
    showAddBtn: true,
    showImportBtn: true,
  },
  CHANNEL_PARTNER: {
    showAddBtn: true,
    showImportBtn: true,
  },
  TRAINER: {
    showAddBtn: false,
    showImportBtn: false,
  },
  SUPER_ADMIN: {
    showAddBtn: true,
    showImportBtn: true,
  },
};

export const canShowPurchaseButton = (role, mode) => {
  if (role !== "CHANNEL_PARTNER") return false;
  return mode === "COURSE";
};

export const FIELD_SECTION_MAP = {
  // Basic Information
  organizationName: "basic",
  contactPersonFirstName: "basic",
  contactPersonLastName: "basic",
  email: "basic",
  mobileNumber: "basic",
  accountStatus: "basic",

  // Organization Details
  gstNumber: "business",
  panNumber: "business",
  state: "business",
  city: "business",
  pincode: "business",
  addressLine1: "business",
  addressLine2: "business",
  landmark: "business",

  // Documents
  companyLogo: "documents",
  supportingDocuments: "documents",
};

export const LETTER_STATUS_OPTIONS = [
  { value: "DRAFT", label: "Draft" },
  { value: "ISSUED", label: "Issued" },
  { value: "EXPIRED", label: "Expired" },
  { value: "PENDING_APPROVAL", label: "Pending_Approval" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
];

export const getStatusColor = (status) => {
  switch (status) {
    case "APPROVED":
    case "ISSUED":
      return "success";
    case "REJECTED":
      return "danger";
    case "PENDING_APPROVAL":
      return "info";
    case "DRAFT":
      return "secondary";
    default:
      return "warning";
  }
};

export const LETTER_TYPE_OPTIONS = [
  { value: "AUTHORIZATION_LETTER", label: "Authorization Letter" },
  { value: "TOOL_LETTER", label: "Tool Letter" },
];

export const LETTER_SCOPE_OPTIONS = [
  { value: "INDIVIDUAL", label: "Individual" },
  { value: "PROJECT_PAID", label: "Project Paid" },
  { value: "PROJECT_FREE", label: "Project Free" },
];

export const LETTER_SCOPE_FILTER_OPTIONS = [
  { value: "INDIVIDUAL", label: "Individual" },
  { value: "PROJECT", label: "Project" },
  { value: "PROJECT_PAID", label: "Project Paid" },
  { value: "PROJECT_FREE", label: "Project Free" },
];

export const PRODUCT_CATEGORY_OPTIONS = [
  { value: "CABLE_ACCESSORIES", label: "Cable Accessories" },
  { value: "RAYSULATE", label: "Raysulate" },
  { value: "MVCC", label: "MVCC" },
  { value: "TLA", label: "TLA" },
];

export const VOLTAGE_CLASS_OPTIONS = [
  { value: "1.1KV", label: "1.1KV" },
  { value: "3.3KV", label: "3.3KV" },
  { value: "6.6KV", label: "6.6KV" },
  { value: "11KV", label: "11KV" },
  { value: "22KV", label: "22KV" },
  { value: "33KV", label: "33KV" },
  { value: "45KV", label: "45KV" },
  { value: "66KV", label: "66KV" },
  { value: "110KV", label: "110KV" },
  { value: "132KV", label: "132KV" },
  { value: "220KV", label: "220KV" },
  { value: "400KV", label: "400KV" },
];

export const TERMINATION_OPTIONS = [
  { value: "INDOOR_HEAT_SHRINK", label: "Indoor Heat Shrink Termination" },
  { value: "OUTDOOR_HEAT_SHRINK", label: "Outdoor Heat Shrink Termination" },
  {
    value: "DRY_GIS_TRANSFORMER",
    label: "Dry type GIS / Transformer Termination",
  },
  { value: "DRY_OUTDOOR", label: "Dry Type Outdoor Termination" },
];

export const PLUGIN_TERMINATION_OPTIONS = [
  { value: "RSTI", label: "RSTI" },
  { value: "ELBC", label: "ELBC" },
  { value: "RPIT", label: "RPIT" },
];

export const JOINT_OPTIONS = [
  { value: "HEAT_SHRINK_STRAIGHT", label: "Heat Shrink Straight Joint" },
  { value: "HEAT_SHRINK_TRANSITION", label: "Heat Shrink Transition Joint" },
  { value: "SINGLE_PIECE_STRAIGHT", label: "Single Piece Straight Joint" },
  { value: "THREE_PIECE_STRAIGHT", label: "Three Piece Straight Joint" },
];

export const NATURE_OF_WORK_OPTIONS = [
  { value: "INSTALLATION", label: "Installation" },
  { value: "SUPERVISION", label: "Supervision" },
];

export const LETTER_FILTER_VALUES = [
  "PRODUCT_CATEGORY",
  "NATURE_OF_WORK",
  "VOLTAGE_CLASS",
  "TERMINATION",
  "PLUG_IN_TERMINATION",
  "JOINTS",
];

export const coursesList = [
  {
    id: 1,
    title: "Electrical Safety",
    code: "ELEC-101", //not in channel partner and instructor
    category: "Safety",
    level: "Beginner",
    courseType: "Recorded",
    accessType: "Paid",
    price: 49.99,
    rating: 4.5, //not in channel partner and instructor
    sessions: 10, //only in channel partner and instructor, it will replace code part
    enrolledStudents: 245, //only in channel partner and instructor, it will replace rating part
    status: "PUBLISHED",
    createdOn: "15 Jan 2025, 10:30 AM",
    createdBy: "John Doe", //not in channel partner and instructor
    image: require("../assets/img/course/panel-wiring.jpg"),
  },
  {
    id: 2,
    title: "Power Systems Advanced",
    code: "PWR-301",
    category: "Power Systems",
    level: "Advanced",
    courseType: "Live",
    accessType: "Free",
    price: 0,
    rating: 4.2,
    sessions: 8,
    enrolledStudents: 120,
    status: "DRAFT",
    createdOn: "18 Jan 2025, 02:15 PM",
    createdBy: "Jane Smith",
    image: require("../assets/img/course/energy_management.jpg"),
  },
  {
    id: 3,
    title: "Industrial Wiring Basics",
    code: "IND-201",
    category: "Electrical",
    level: "Beginner",
    courseType: "Recorded",
    accessType: "Paid",
    price: 39.99,
    rating: 4.8,
    sessions: 23,
    enrolledStudents: 410,
    status: "PUBLISHED",
    createdOn: "20 Jan 2025, 09:45 AM",
    createdBy: "Alice Johnson",
    image: require("../assets/img/course/industrial_wiring.jpg"),
  },
  {
    id: 4,
    title: "Substation Operations",
    code: "SUB-401",
    category: "Power Systems",
    level: "Intermediate",
    courseType: "Live",
    accessType: "Paid",
    price: 59.99,
    rating: 4.1,
    sessions: 15,
    enrolledStudents: 198,
    status: "PUBLISHED",
    createdOn: "22 Jan 2025, 11:20 AM",
    createdBy: "Robert Brown",
    image: require("../assets/img/course/industrial_wiring.jpg"),
  },
  {
    id: 5,
    title: "Transformer Maintenance",
    code: "TRF-301",
    category: "Electrical",
    level: "Advanced",
    courseType: "Recorded",
    accessType: "Paid",
    price: 69.99,
    rating: 4.6,
    sessions: 18,
    enrolledStudents: 95,
    status: "DRAFT",
    createdOn: "24 Jan 2025, 04:50 PM",
    createdBy: "Emily Davis",
    image: require("../assets/img/course/panel-wiring.jpg"),
  },
  {
    id: 6,
    title: "Energy Management Basics",
    code: "ENG-101",
    category: "Energy",
    level: "Beginner",
    courseType: "Recorded",
    accessType: "Free",
    price: 0,
    rating: 4.3,
    sessions: 12,
    enrolledStudents: 560,
    status: "PUBLISHED",
    createdOn: "26 Jan 2025, 08:10 AM",
    createdBy: "Michael Scott",
    image: require("../assets/img/course/energy_management.jpg"),
  },
  {
    id: 7,
    title: "Panel Wiring Techniques",
    code: "PNL-202",
    category: "Electrical",
    level: "Intermediate",
    courseType: "Live",
    accessType: "Paid",
    price: 54.99,
    rating: 4.0,
    sessions: 9,
    enrolledStudents: 140,
    status: "DRAFT",
    createdOn: "27 Jan 2025, 01:35 PM",
    createdBy: "Samantha Lee",
    image: require("../assets/img/course/panel-wiring.jpg"),
  },
  {
    id: 8,
    title: "Advanced Electrical Safety",
    code: "ELEC-201",
    category: "Safety",
    level: "Advanced",
    courseType: "Recorded",
    accessType: "Paid",
    price: 59.99,
    rating: 4.7,
    sessions: 20,
    enrolledStudents: 320,
    status: "PUBLISHED",
    createdOn: "28 Jan 2025, 05:05 PM",
    createdBy: "John Doe",
    image: require("../assets/img/course/energy_management.jpg"),
  },
  {
    id: 9,
    title: "Grid Operations Fundamentals",
    code: "GRID-101",
    category: "Power Systems",
    level: "Beginner",
    courseType: "Live",
    accessType: "Free",
    price: 0,
    rating: 4.4,
    sessions: 11,
    enrolledStudents: 275,
    status: "PUBLISHED",
    createdOn: "29 Jan 2025, 10:00 AM",
    createdBy: "Jane Smith",
    image: require("../assets/img/course/industrial_wiring.jpg"),
  },
];

export const instructorsList = [
  {
    id: 1,
    fullName: "Rahul Sharma",
    email: "rahul.sharma@training.com",
    phone: "9876543210",
    experienceYears: 8,
    skills: ["Cable Jointing", "Substation Maintenance"],
    profilePhoto: "rahul.png",
    gender: "Male",
    role: "Instructor",
    status: "ACTIVE",
    assignedCourses: ["Electrical Safety", "Power Systems"],
    createdBy: "ADMIN_001",
    createdOn: "2025-01-10T10:30:00Z",
  },
  {
    id: 2,
    fullName: "Priya Verma",
    email: "priya.verma@training.com",
    phone: "9123456789",
    experienceYears: 5,
    skills: ["HVAC Maintenance"],
    profilePhoto: "priya.png",
    gender: "Female",
    role: "Instructor",
    status: "ACTIVE",
    assignedCourses: [],
    createdBy: "ADMIN_002",
    createdOn: "2025-01-12T15:45:00Z",
  },
  {
    id: 3,
    fullName: "Amit Kulkarni",
    email: "",
    phone: "9988776655",
    experienceYears: 12,
    skills: ["Industrial Wiring", "Panel Installation"],
    profilePhoto: "",
    gender: "Prefer not to say",
    role: "Instructor",
    status: "INACTIVE",
    assignedCourses: ["Industrial Wiring Advanced"],
    createdBy: "ADMIN_001",
    createdOn: "2025-01-15T09:20:00Z",
  },
  {
    id: 4,
    fullName: "Suresh Patil",
    email: "suresh.patil@training.com",
    phone: "9012345678",
    experienceYears: 15,
    skills: ["Substation Maintenance"],
    profilePhoto: "suresh.png",
    gender: "Male",
    role: "Instructor",
    status: "ACTIVE",
    assignedCourses: ["Substation Operations"],
    createdBy: "ADMIN_003",
    createdOn: "2025-01-18T11:00:00Z",
  },
  {
    id: 5,
    fullName: "Neha Joshi",
    email: "neha.joshi@training.com",
    phone: "9345678901",
    experienceYears: 4,
    skills: ["Energy Auditing"],
    profilePhoto: "neha.png",
    gender: "Female",
    role: "Instructor",
    status: "ACTIVE",
    assignedCourses: ["Energy Management Basics"],
    createdBy: "ADMIN_002",
    createdOn: "2025-01-20T14:10:00Z",
  },
  {
    id: 6,
    fullName: "Vikram Singh",
    email: "vikram.singh@training.com",
    phone: "9567890123",
    experienceYears: 10,
    skills: ["Cable Jointing"],
    profilePhoto: "vikram.png",
    gender: "Male",
    role: "Instructor",
    status: "ACTIVE",
    assignedCourses: ["Underground Cabling"],
    createdBy: "ADMIN_001",
    createdOn: "2025-01-22T09:40:00Z",
  },
  {
    id: 7,
    fullName: "Anjali Deshmukh",
    email: "anjali.deshmukh@training.com",
    phone: "9789012345",
    experienceYears: 6,
    skills: ["Electrical Safety"],
    profilePhoto: "anjali.png",
    gender: "Female",
    role: "Instructor",
    status: "ACTIVE",
    assignedCourses: ["Electrical Safety"],
    createdBy: "ADMIN_003",
    createdOn: "2025-01-25T16:00:00Z",
  },
  {
    id: 8,
    fullName: "Manoj Yadav",
    email: "manoj.yadav@training.com",
    phone: "9898123456",
    experienceYears: 18,
    skills: ["Transformer Maintenance"],
    profilePhoto: "manoj.png",
    gender: "Male",
    role: "Instructor",
    status: "INACTIVE",
    assignedCourses: [],
    createdBy: "ADMIN_002",
    createdOn: "2025-01-27T10:20:00Z",
  },
  {
    id: 9,
    fullName: "Pooja Nair",
    email: "pooja.nair@training.com",
    phone: "9678901234",
    experienceYears: 7,
    skills: ["Panel Installation"],
    profilePhoto: "pooja.png",
    gender: "Female",
    role: "Instructor",
    status: "ACTIVE",
    assignedCourses: ["Panel Wiring"],
    createdBy: "ADMIN_001",
    createdOn: "2025-01-28T13:50:00Z",
  },
  {
    id: 10,
    fullName: "Rakesh Mehta",
    email: "rakesh.mehta@training.com",
    phone: "9900123456",
    experienceYears: 20,
    skills: ["Power Systems"],
    profilePhoto: "rakesh.png",
    gender: "Male",
    role: "Instructor",
    status: "ACTIVE",
    assignedCourses: ["Power Systems Advanced"],
    createdBy: "ADMIN_003",
    createdOn: "2025-01-30T09:00:00Z",
  },

  {
    id: 11,
    fullName: "Rahul Sharma",
    email: "rahul.sharma@training.com",
    phone: "9876543210",
    experienceYears: 8,
    skills: ["Cable Jointing", "Substation Maintenance"],
    profilePhoto: "rahul.png",
    gender: "Male",
    role: "Instructor",
    status: "ACTIVE",
    assignedCourses: ["Electrical Safety", "Power Systems"],
    createdBy: "ADMIN_001",
    createdOn: "2025-01-10T10:30:00Z",
  },
  {
    id: 12,
    fullName: "Priya Verma",
    email: "priya.verma@training.com",
    phone: "9123456789",
    experienceYears: 5,
    skills: ["HVAC Maintenance"],
    profilePhoto: "priya.png",
    gender: "Female",
    role: "Instructor",
    status: "ACTIVE",
    assignedCourses: [],
    createdBy: "ADMIN_002",
    createdOn: "2025-01-12T15:45:00Z",
  },
  {
    id: 13,
    fullName: "Amit Kulkarni",
    email: "",
    phone: "9988776655",
    experienceYears: 12,
    skills: ["Industrial Wiring", "Panel Installation"],
    profilePhoto: "",
    gender: "Prefer not to say",
    role: "Instructor",
    status: "INACTIVE",
    assignedCourses: ["Industrial Wiring Advanced"],
    createdBy: "ADMIN_001",
    createdOn: "2025-01-15T09:20:00Z",
  },
  {
    id: 14,
    fullName: "Suresh Patil",
    email: "suresh.patil@training.com",
    phone: "9012345678",
    experienceYears: 15,
    skills: ["Substation Maintenance"],
    profilePhoto: "suresh.png",
    gender: "Male",
    role: "Instructor",
    status: "ACTIVE",
    assignedCourses: ["Substation Operations"],
    createdBy: "ADMIN_003",
    createdOn: "2025-01-18T11:00:00Z",
  },
];

export const COURSES = [
  { label: "Electrical Safety", value: "Electrical Safety" },
  { label: "Power Systems Advanced", value: "Power Systems Advanced" },
  { label: "Industrial Wiring Basics", value: "Industrial Wiring Basics" },
  { label: "Substation Operations", value: "Substation Operations" },
  { label: "Transformer Maintenance", value: "Transformer Maintenance" },
  { label: "Energy Management Basics", value: "Energy Management Basics" },
  { label: "Advanced Electrical Safety", value: "Advanced Electrical Safety" },
  {
    label: "Grid Operations Fundamentals",
    value: "Grid Operations Fundamentals",
  },
];

export const BATCH_OPTIONS = [
  { label: "Batch A1", value: "Batch A1" },
  { label: "Batch A2", value: "Batch A2" },
  { label: "Batch B1", value: "Batch B1" },
  { label: "Batch B2", value: "Batch B2" },
  { label: "Batch C1", value: "Batch C1" },
  { label: "Batch C2", value: "Batch C2" },
  { label: "Batch D1", value: "Batch D1" },
  { label: "Batch D2", value: "Batch D2" },
  { label: "Batch E1", value: "Batch E1" },
  { label: "Batch E2", value: "Batch E2" },
  { label: "Batch F1", value: "Batch F1" },
  { label: "Batch F2", value: "Batch F2" },
  { label: "Batch G1", value: "Batch G1" },
  { label: "Batch H1", value: "Batch H1" },
  { label: "Batch I1", value: "Batch I1" },
];

export const batchData = [
  {
    id: 1,
    batchId: "BATCH001",
    courseName: "Electrical Safety",
    sessionName: "Morning Batch",
    startDate: "2026-04-10",
    endDate: "2026-05-10",
    instructors: ["John Doe", "Jane Smith"],
    offlineTrainingCenter: "Pune Industrial Training Center",
    minParticipant: 15,
    maxParticipant: 30,
    enrolledCount: 25,
    totalSeats: 30,
    availableSeats: 5,
    status: "Upcoming",
  },
  {
    id: 2,
    batchId: "BATCH002",
    courseName: "Power Systems Advanced",
    sessionName: "Evening Batch",
    startDate: "2026-03-01",
    endDate: "2026-04-01",
    instructors: ["Jane Smith", "Rahul Verma"],
    offlineTrainingCenter: "Bangalore Skill Hub",
    minParticipant: 20,
    maxParticipant: 30,
    enrolledCount: 30,
    totalSeats: 30,
    availableSeats: 0,
    status: "Completed",
  },
  {
    id: 3,
    batchId: "BATCH003",
    courseName: "Industrial Wiring Basics",
    sessionName: "Weekend Batch",
    startDate: "2026-04-05",
    endDate: "2026-06-05",
    instructors: ["Amit Kumar", "Neha Sharma"],
    offlineTrainingCenter: "Delhi Technical Academy",
    minParticipant: 10,
    maxParticipant: 25,
    enrolledCount: 18,
    totalSeats: 25,
    availableSeats: 7,
    status: "Ongoing",
  },
  {
    id: 4,
    batchId: "BATCH004",
    courseName: "Substation Operations",
    sessionName: "Morning Batch",
    startDate: "2026-04-15",
    endDate: "2026-06-15",
    instructors: ["Neha Sharma", "Deepak Nair"],
    offlineTrainingCenter: "Chennai Manufacturing Institute",
    minParticipant: 10,
    maxParticipant: 20,
    enrolledCount: 10,
    totalSeats: 20,
    availableSeats: 10,
    status: "Upcoming",
  },
  {
    id: 5,
    batchId: "BATCH005",
    courseName: "Transformer Maintenance",
    sessionName: "Afternoon Batch",
    startDate: "2026-02-01",
    endDate: "2026-03-01",
    instructors: ["Rahul Verma", "Priya Singh"],
    offlineTrainingCenter: "Ahmedabad Industrial School",
    minParticipant: 15,
    maxParticipant: 20,
    enrolledCount: 20,
    totalSeats: 20,
    availableSeats: 0,
    status: "Completed",
  },
  {
    id: 6,
    batchId: "BATCH006",
    courseName: "Energy Management Basics",
    sessionName: "Evening Batch",
    startDate: "2026-04-01",
    endDate: "2026-05-01",
    instructors: ["Priya Singh", "Karan Shah"],
    offlineTrainingCenter: "Pune Industrial Training Center",
    minParticipant: 10,
    maxParticipant: 25,
    enrolledCount: 15,
    totalSeats: 25,
    availableSeats: 10,
    status: "Ongoing",
  },
  {
    id: 7,
    batchId: "BATCH007",
    courseName: "Advanced Electrical Safety",
    sessionName: "Weekend Batch",
    startDate: "2026-05-01",
    endDate: "2026-07-01",
    instructors: ["Vikram Joshi", "Rohit Gupta"],
    offlineTrainingCenter: "Bangalore Skill Hub",
    minParticipant: 10,
    maxParticipant: 30,
    enrolledCount: 5,
    totalSeats: 30,
    availableSeats: 25,
    status: "Upcoming",
  },
  {
    id: 8,
    batchId: "BATCH008",
    courseName: "Grid Operations Fundamentals",
    sessionName: "Morning Batch",
    startDate: "2026-03-10",
    endDate: "2026-04-20",
    instructors: ["Sneha Patil", "Anjali Mehta"],
    offlineTrainingCenter: "Delhi Technical Academy",
    minParticipant: 15,
    maxParticipant: 25,
    enrolledCount: 22,
    totalSeats: 25,
    availableSeats: 3,
    status: "Ongoing",
  },
  {
    id: 9,
    batchId: "BATCH009",
    courseName: "Electrical Safety",
    sessionName: "Evening Batch",
    startDate: "2026-01-01",
    endDate: "2026-02-01",
    instructors: ["Anjali Mehta", "John Doe"],
    offlineTrainingCenter: "Chennai Manufacturing Institute",
    minParticipant: 10,
    maxParticipant: 20,
    enrolledCount: 18,
    totalSeats: 20,
    availableSeats: 2,
    status: "Completed",
  },
  {
    id: 10,
    batchId: "BATCH010",
    courseName: "Power Systems Advanced",
    sessionName: "Weekend Batch",
    startDate: "2026-04-20",
    endDate: "2026-06-20",
    instructors: ["Karan Shah", "Amit Kumar"],
    offlineTrainingCenter: "Ahmedabad Industrial School",
    minParticipant: 10,
    maxParticipant: 25,
    enrolledCount: 12,
    totalSeats: 25,
    availableSeats: 13,
    status: "Upcoming",
  },
  {
    id: 11,
    batchId: "BATCH011",
    courseName: "Industrial Wiring Basics",
    sessionName: "Morning Batch",
    startDate: "2026-04-01",
    endDate: "2026-06-01",
    instructors: ["Rohit Gupta", "Sneha Patil"],
    offlineTrainingCenter: "Pune Industrial Training Center",
    minParticipant: 15,
    maxParticipant: 30,
    enrolledCount: 20,
    totalSeats: 30,
    availableSeats: 10,
    status: "Ongoing",
  },
  {
    id: 12,
    batchId: "BATCH012",
    courseName: "Substation Operations",
    sessionName: "Evening Batch",
    startDate: "2026-05-10",
    endDate: "2026-07-10",
    instructors: ["Deepak Nair", "Priya Singh"],
    offlineTrainingCenter: "Bangalore Skill Hub",
    minParticipant: 10,
    maxParticipant: 20,
    enrolledCount: 8,
    totalSeats: 20,
    availableSeats: 12,
    status: "Upcoming",
  },
];

export const BATCH_STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
  { value: "NOT_STARTED", label: "Not Started" },
  { value: "STARTED", label: "Started" },
  { value: "INPROGRESS", label: "Ongoing" },
  { value: "COMPLETED", label: "Completed" },
  { value: "CANCELLED", label: "Cancelled" },
];

export const STATUS_BADGE_COLORS = {
  ACTIVE: "success",
  INACTIVE: "warning",
  NOT_STARTED: "secondary",
  STARTED: "primary",
  INPROGRESS: "info",
  COMPLETED: "success",
  CANCELLED: "danger",
};

export const ANSWER_TYPES = [
  { value: "SINGLE_CHOICE", label: "Single Choice" },
  { value: "MULTIPLE_CHOICE", label: "Multiple Choice" },
  { value: "TRUE_FALSE", label: "True / False" },
];

export const TAG_OPTIONS = [
  { value: "ELECTRICAL", label: "Electrical" },
  { value: "MECHANICAL", label: "Mechanical" },
  { value: "CIVIL", label: "Civil" },
  { value: "ELECTRONICS", label: "Electronics" },
];

export const LEVEL_OPTIONS = [
  { value: "BEGINNER", label: "Beginner" },
  { value: "INTERMEDIATE", label: "Intermediate" },
  { value: "ADVANCED", label: "Advanced" },
];

export const LANGUAGE_OPTIONS = [
  { value: "ENGLISH", label: "English" },
  { value: "HINDI", label: "Hindi" },
  { value: "ENGLISH_HINDI", label: "English, Hindi" },
];

export const QUESTION_LANGUAGE_OPTIONS = [
  { value: "ENGLISH", label: "English" },
  { value: "HINDI", label: "Hindi" },
];

export const QUESTION_BANK_OPTIONS = [
  { value: "ELECTRICAL_BASICS", label: "Electrical Basics" },
  { value: "POWER_SYSTEMS", label: "Power Systems" },
  { value: "SAFETY_TRAINING", label: "Safety Training" },
];

export const TRAINEE_TYPE_OPTIONS = [
  { value: "JOINTER", label: "Jointer" },
  { value: "STUDENT", label: "Student" },
  { value: "FRESHER", label: "Fresher" },
  { value: "PROFESSIONAL", label: "Professional" },
  { value: "TECHNICIAN", label: "Technician" },
  { value: "ENGINEER", label: "Engineer" },
];

export const TRAINEE_CATEGORY_OPTIONS = [
  { value: "ORGANIZATION", label: "Organization" },
  { value: "THIRD_PARTY_CONTRACTOR", label: "3rd-Party Contractor" },
  { value: "FREELANCER", label: "Freelancer" },
  { value: "RRL", label: "RRL" },
];

export const CHANNEL_PARTNER_OPTIONS = [
  { value: "ABC_PARTNER", label: "ABC Partner" },
  { value: "XYZ_PARTNER", label: "XYZ Partner" },
  { value: "GLOBAL_TRAINING_PARTNER", label: "Global Training Partner" },
];

export const COURSE_EDIT_DATA = {
  courseNameID: 1,
  courseName: "Electrical Safety",

  courseCategoryID: 1,
  courseCategoryName: "Electrical",

  courseDescription:
    "<p>This course covers electrical safety practices, hazards, PPE usage, and compliance requirements.</p>",

  courseUsers: "BOTH",

  level: "BEGINNER",

  accessType: "PAID",
  payingUserType: "BOTH",
  coursePrice: 49.99,

  courseType: "LIVE",
  contentDeliveryMode: "OFFLINE",

  assessmentType: "BOTH",

  trainingCenterID: {
    value: 1,
    label: "Pune Industrial Training Center",
  },

  sessionLink: "",

  courseLanguage: [
    {
      value: "ENGLISH",
      label: "English",
    },
  ],

  requiredPrerequisiteDocuments: true,

  prerequisitesDocument: [
    {
      value: 1,
      label: "Aadhar Card",
    },
    {
      value: 2,
      label: "PAN Card",
    },
  ],

  notes: "Please carry original documents during training.",

  enableCertificate: true,

  courseCertificateIssuanceCriteria: [
    {
      value: "ATTENDANCE",
      label: "Attendance",
    },
  ],

  criteriaValue: {
    ATTENDANCE: {
      value: "80",
      label: "80%",
    },
  },

  courseCertificateTemplate: {
    durationType: "YEAR",
    durationValue: 1,
  },
};
export const fieldToSectionMap = {
  firstName: "basic",
  lastName: "basic",
  email: "basic",
  mobile: "basic",
  dob: "basic",
  gender: "basic",
  governmentID: "basic",
  status: "basic",
  profilePhoto: "basic",
  preRequisitesDocuments: "basic",
  addressLine1: "traineeDetails",
  addressLine2: "traineeDetails",
  landmark: "traineeDetails",
  state: "traineeDetails",
  city: "traineeDetails",
  pincode: "traineeDetails",
  traineeType: "traineeClassification",
  traineeCategory: "traineeClassification",
  channelPartner: "traineeClassification",
  organizationName: "traineeClassification",
};

export const sectionLabels = {
  basic: "basic information",
  traineeDetails: "address details",
  traineeClassification: "trainee classification",
};

export const batchFieldToSectionMap = {
  courseID: "batchInfo",
  name: "batchInfo",
  trainingCenterID: "batchInfo",
  trainerIds: "batchInfo",
  Trainers: "batchInfo",
  virtualMeetingUrl: "batchInfo",
  batchLanguage: "batchInfo",
  minParticipant: "batchInfo",
  maxParticipant: "batchInfo",
  capacityStatus: "batchInfo",

  registrationStartDate: "registrationTimeline",
  registrationEndDate: "registrationTimeline",
  batchStartDate: "registrationTimeline",
  batchEndDate: "registrationTimeline",
  batchStartTime: "registrationTimeline",
  batchEndTime: "registrationTimeline",

  description: "description",
  status: "description",
};

export const batchSectionLabels = {
  batchInfo: "batch information & capacity",
  registrationTimeline: "schedule & registration",
  description: "additional information",
};

export const channelPartnerFieldToSectionMap = {
  organizationName: "basic",
  contactPersonFirstName: "basic",
  contactPersonLastName: "basic",
  contactPersonEmail: "basic",
  contactPersonMobile: "basic",
  status: "basic",

  gstNo: "business",
  panNo: "business",
  lineOne: "business",
  lineTwo: "business",
  landmark: "business",
  stateID: "business",
  cityID: "business",
  pincode: "business",

  companyLogo: "documents",
  supportingDocuments: "documents",
};

export const channelPartnerSectionLabels = {
  basic: "basic information",
  business: "organization details",
  documents: "branding & documents",
};

export const LETTERS_TYPE_OPTIONS = [
  { value: "AUTHORIZATION_LETTER", label: "Authorization Letter" },
  { value: "TOOL_LETTER", label: "Tool Letter" },
];

export const courseFieldToSectionMap = {
  // General
  courseNameID: "general",
  courseCategoryID: "general",
  level: "general",
  courseDescription: "general",
  courseMedia: "general",

  // Configurations
  courseUsers: "configurations",
  courseLanguage: "configurations",
  accessType: "configurations",
  payingUserType: "configurations",
  coursePrice: "configurations",
  courseType: "configurations",
  contentDeliveryMode: "configurations",
  trainingCenterID: "configurations",
  assessmentType: "configurations",
  sessionLink: "configurations",

  // Prerequisites
  requiredPrerequisiteDocuments: "prerequisites",
  coursePrerequisiteDocument:"prerequisites",
  // prerequisitesDocument: "prerequisites",
  notes: "prerequisites",

  // Certificate
  enableCertificate: "certificate",
  courseCertificateIssuanceCriteria: "certificate",
  courseCertificateTemplate: "certificate",
  certificateTemplateType: "certificate",
  completionCertificateValidity: "certificate",
  completionCertificateTemplate: "certificate",
  participationCertificateTemplate: "certificate",
};

export const courseSectionLabels = {
  general: "general",
  configurations: "configurations",
  prerequisites: "prerequisites documents",
  lessons: "lessons",
  certificate: "certificate",
};

export const validityTypeOptions = [
  { value: "DAYS", label: "Day" },
  { value: "MONTH", label: "Month" },
  { value: "YEAR", label: "Year" },
];

export const lessons = [
  {
    id: 1,
    lessonName: "Lesson 1: Cable Jointing Basics",
    type: "IMAGE",
    duration: "10 min",
    description:
      "This introductory video covers the importance of proper cable jointing in low-voltage systems, common applications, and an overview of tools used in the trade.",
    color: "success",
  },
  {
    id: 2,
    lessonName: "Lesson 2: Personal Protective Equipment",
    type: "IMAGE",
    duration: "10 min",
    description:
      "Procedures for ensuring safe cable jointing environments and correct usage of PPE.",
    color: "danger",
  },
  {
    id: 3,
    lessonName: "Lesson 3: Cable Preparation Techniques",
    type: "DOCUMENT",
    duration: "10 min",
    description:
      "Step-by-step instructions for preparing LV cables for jointing.",
    color: "info",
  },
  {
    id: 4,
    lessonName: "Lesson 4: Safety Guidelines & Best Practices",
    type: "DOCUMENT",
    duration: "20 min",
    description:
      "Learn essential safety protocols, hazard prevention, and compliance standards.",
    color: "danger",
  },
  {
    id: 5,
    lessonName: "Lesson 5: Cable Jointing Practical Demonstration",
    type: "SHEET",
    duration: "25 min",
    description:
      "A complete hands-on demonstration of LV cable jointing techniques in real-world scenarios.",
    color: "success",
  },
];

export const VALIDATION_MODE = {
  DRAFT: "SAVE_AS_DRAFT",
  READY: "READY_TO_PUBLISH",
  PUBLISH: "PUBLISH",
};

//course dd
export const ASSESSMENT_COURSE_OPTIONS = [
  { value: "Electrical_Safety", label: "Electrical Saftety" },
  { value: "Power_Systems _Advanced", label: "Power System advance" },
  { value: "Industrial_Wiring _Basics", label: "Industrial wiring Basic" },
  { value: "Substation_Operations", label: "Substation_operation" },
  { value: "Transformer_Maintenance", label: "Transformer Maintance" },
  { value: "Energy Management_Basics", label: "Energy Mangement Basic" },
  { value: "Panel_Wiring _Techniques", label: "Panel Wiring Techniques" },
  { value: "Advanced_Electrical_Safety", label: "Advanced Electrical Safety" },
  { value: "Power_Systems", label: "power Sysyem " },
];
export const ASSESSMENT_CRADS = [
  {
    title: "8",
    subtitle: "Total Assessment",
    icon: "ni ni-collection", // Education / Student
    iconClass: "primary",
  },
  {
    title: "3",
    subtitle: "Upcoming",
    icon: "ni ni-calendar-grid-58", // Calendar
    iconClass: "success",
  },
  {
    title: "4",
    subtitle: "Completed",
    icon: "ni ni-check-bold", // Completed
    iconClass: "purple",
  },
  {
    title: "Drafts",
    subtitle: "Not published",
    icon: "ni ni-single-copy-04", // Draft document
    iconClass: "warning",
  },
];

export const CONTENT_DELIVERY_MODE_MAP = {
  Online: "ONLINE",
  Offline: "OFFLINE",
  Hybrid: "BOTH",
};

export const COURSE_STATUS_OPTIONS = [
  {
    label: "Draft",
    value: "DRAFT",
  },
  {
    label: "Ready To Publish",
    value: "READY_TO_PUBLISH",
  },
  {
    label: "Published",
    value: "PUBLISHED",
  },
];

export const CONTENT_DELIVERY_MODE_LABELS = {
  OFFLINE: "Offline",
  ONLINE: "Online",
  BOTH: "Online, Offline",
};

export const ASSESSMENT_TYPE_LABELS = {
  TECHNICAL: "Technical",
  PRACTICAL: "Practical",
  BOTH: "Technical, Practical",
};

export const PARTICIPANT_TYPE_LABELS = {
  EXTERNAL: "External",
  RAYCHEM: "Raychem",
  BOTH: "External, Raychem",
};


export const PAYMENT_OPTIONS = [
  { value: "ONLINE", label: "Online" },
  { value: "OFFLINE", label: "Offline" },
];


export const PAYMENT_STATUS = [
  { value: "PENDING", label: "Pending for Approval" },
  { value: "CAPTURED", label: "Approved" },
  { value: "FAILED", label: "Rejected" },
];

export const BATCHS_STATUS_OPTIONS = [
  { label: "Active", value: "ACTIVE" },
  // { label: "Not Started", value: "NOT_STARTED" },
  // { label: "Started", value: "STARTED" },
  { label: "Ongoing", value: "INPROGRESS" },
  { label: "Completed", value: "COMPLETED" },
  { label: "Inactive", value: "INACTIVE" },
  { label: "Cancelled", value: "CANCELLED" },
];

export const SESSION_TYPE_OPTIONS = [
  { value: "OFFLINE", label: "Offline" },
];

export const ALL_SESSION_TYPE_OPTIONS = [
  { value: "OFFLINE", label: "Offline" },
  { value: "ONLINE", label: "Online" },
];

export const SESSION_STATUS_OPTIONS = [
  { value: "INPROGRESS", label: "Ongoing" },
  { value: "COMPLETED", label: "Completed" }
];

export const DURATION_OPTIONS = [
  { value: "15", label: "15 min" },
  { value: "30", label: "30 min" },
  { value: "45", label: "45 min" },
  { value: "60", label: "1 hour" },
  { value: "75", label: "1 hour 15 min" },
  { value: "90", label: "1 hour 30 min" },
  { value: "105", label: "1 hour 45 min" },
  { value: "120", label: "2 hours" },
  { value: "135", label: "2 hours 15 min" },
  { value: "150", label: "2 hours 30 min" },
  { value: "165", label: "2 hours 45 min" },
  { value: "180", label: "3 hours" },
];
export const APPROVAL_STATUS_OPTIONS = [
  { label: "Pending For Approval", value: "PENDING" },
  { label: "Payment Rejected", value: "FAILED" },
  { label: "Payment Approved", value: "CAPTURED" },
];